import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetAPINotTreat = api.create('dponet', false)

const get = async ({ paymentContractId, ...params }) => {
  return await dponetAPI.get(
    `backoffice/payment_contracts/${paymentContractId}/services`,
    { params },
  )
}

const create = async ({ paymentContractId, ...data }) => {
  return await dponetAPI.post(
    `backoffice/payment_contracts/${paymentContractId}/services`,
    { paymentService: data },
  )
}

const update = async ({ paymentContractId, paymentServiceId, ...data }) => {
  return await dponetAPI.put(
    `backoffice/payment_contracts/${paymentContractId}/services/${paymentServiceId}`,
    { paymentService: data },
  )
}

const changeStatus = async ({ paymentContractId, paymentServiceId }) => {
  return await dponetAPI.patch(
    `backoffice/payment_contracts/${paymentContractId}/services/${paymentServiceId}/change_status`,
  )
}

const destroy = async ({ paymentContractId, paymentServiceId }) => {
  return await dponetAPI.delete(
    `backoffice/payment_contracts/${paymentContractId}/services/${paymentServiceId}`,
  )
}

const getCompanies = async ({ paymentContractId, paymentServiceId }) => {
  return await dponetAPINotTreat.get(
    `backoffice/payment_contracts/${paymentContractId}/services/${paymentServiceId}/companies`,
  )
}

const selectCompany = async ({
  paymentContractId,
  paymentServiceId,
  companyId,
}) => {
  return await dponetAPINotTreat.post(
    `backoffice/payment_contracts/${paymentContractId}/services/${paymentServiceId}/companies`,
    { companyId },
  )
}

const unselectCompany = async ({
  paymentContractId,
  paymentServiceId,
  companyId,
}) => {
  return await dponetAPINotTreat.delete(
    `backoffice/payment_contracts/${paymentContractId}/services/${paymentServiceId}/companies/${companyId}`,
  )
}

const paymentContractServices = {
  get,
  create,
  update,
  changeStatus,
  destroy,
  getCompanies,
  selectCompany,
  unselectCompany,
}

export default paymentContractServices
